<template>
  <div
    v-scroll-lock
    class="animate__animated animate__fadeIn fixed inset-0 h-full flex flex-col items-center bg-black/50 z-10 overflow-y-auto"
    @click.self="handleClose"
  >
    <div
      ref="content"
      class="animate__animated animate__fadeInDownBig w-full flex flex-col"
      :class="contentClass"
    >
      <div class="bg-capino-light rounded-b-2xl">
        <div class="flex justify-end border-b border-gray-200">
          <div class="p-6 cursor-pointer" @click="handleClose">
            <BaseIcon icon="cross" />
          </div>
        </div>

        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { animate } from 'motion'

import BaseIcon from '@/components/Base/BaseIcon.vue'

export default {
  name: 'BaseModal',

  components: { BaseIcon },

  props: {
    contentClass: { type: String, default: 'max-w-6xl' }
  },

  mounted() {
    document.body.appendChild(this.$el)
  },

  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },

  methods: {
    handleClose() {
      this.$refs.content.classList.add('animate__fadeOutUpBig')

      animate(this.$el, { opacity: 0 }, { duration: 0.3 }).finished.then(() => {
        this.$emit('close')
      })
    }
  }
}
</script>
